import React, { memo } from 'react';
import Icon from '../Icon';
import { IconBackgroundColors, IconColors, IconSizes, IconVariants, NO_SOUND_LEVEL } from '../../constants';
import './MicLevel.scss';
const MicLevel = ({ level = NO_SOUND_LEVEL, participantId }) => {
    const gradientValue = `${level}%`;
    return (<Icon color={IconColors.Primary} backgroundColor={IconBackgroundColors.Primary} size={IconSizes.Medium} variant={IconVariants.Plain}>
      <svg viewBox="0 0 24 24">
        <defs>
          <clipPath id="shape">
            <rect x="8.85" y="1" width="7.05" height="15.1" rx="2.8" fill="red"/>
          </clipPath>
          <linearGradient className="mic-level-gradient" id="level" x1="0%" y1="100%" x2="0%" y2="0%">
            <stop offset="0%" stopColor="currentColor"/>
            <stop data-stream-volume-id={participantId} offset={gradientValue} stopColor="currentColor"/>
            <stop data-stream-volume-id={participantId} offset={gradientValue} stopColor="transparent"/>
            <stop offset="100%" stopColor="transparent"/>
          </linearGradient>
        </defs>
        <g>
          <path fillRule="evenodd" clipRule="evenodd" d="M18.737 9.25v4.125c0 2.75-2.83 5.5-5.661 5.5v2.75h4.246V23H7.415v-1.375h4.246v-2.75c-2.83 0-5.661-2.75-5.661-5.5V9.25h1.415v4.125c0 2.063 2.123 4.125 4.246 4.125h1.415c2.123 0 4.246-2.063 4.246-4.125V9.25h1.415zM11.667 1h1.402c1.572 0 2.837 1.226 2.837 2.739v9.647c0 1.501-1.27 2.739-2.837 2.739h-1.401c-1.572 0-2.838-1.226-2.838-2.739V3.739C8.83 2.238 10.1 1 11.668 1z"/>
          <rect x="8.85" y="1" width="7.1" height="15.1" clipPath="url(#shape)" fill="url(#level)"/>
        </g>
      </svg>
    </Icon>);
};
function areEqual(prevProps, nextProps) {
    return prevProps.level === nextProps.level;
}
export default memo(MicLevel, areEqual);
